class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    if (window.UniversalScrollLock) {
      window.UniversalScrollLock.sync();
    }

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    if (!this.detailsContainer.hasAttribute('open') || this.detailsContainer.classList.contains('is-closing')) return;

    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    document.body.removeEventListener('click', this.onBodyClickEvent);

    this.detailsContainer.classList.add('is-closing');

    const drawer = this.detailsContainer.querySelector('.search-drawer, .search-modal__content');
    const finishClose = () => {
      this.detailsContainer.removeAttribute('open');
      this.detailsContainer.classList.remove('is-closing');
      if (window.UniversalScrollLock) {
        window.UniversalScrollLock.sync();
      }
    };

    if (drawer) {
      let done = false;
      const onTransitionEnd = (event) => {
        if (event.target !== drawer) return;
        done = true;
        drawer.removeEventListener('transitionend', onTransitionEnd);
        finishClose();
      };
      drawer.addEventListener('transitionend', onTransitionEnd);
      // Fallback: bir sebeple transitionend tetiklenmezse (ör. görünmez sekme) yine de kapat
      setTimeout(() => {
        if (!done) {
          drawer.removeEventListener('transitionend', onTransitionEnd);
          finishClose();
        }
      }, 500);
    } else {
      finishClose();
    }
  }
}

customElements.define('details-modal', DetailsModal);
